export default {
  title: {
    'zh-cn': '我的客户-组织管理',
    'zh-tw': '我的客戶-組織管理',
    'en': 'My Customer - Organization Management'
  },
  // 搜索表单
  organizationName: {
    'zh-cn': '组织机构名称',
    'zh-tw': '組織機構名稱',
    'en': 'Organization Name'
  },
  pleaseInputKeyword: {
    'zh-cn': '请输入关键字',
    'zh-tw': '請輸入關鍵字',
    'en': 'Please input keyword'
  },
  add: {
    'zh-cn': '新增',
    'zh-tw': '新增',
    'en': 'Add'
  },
  // 表格列
  parentOrganization: {
    'zh-cn': '所属上级',
    'zh-tw': '所屬上級',
    'en': 'Parent Organization'
  },
  contactName: {
    'zh-cn': '联系人姓名',
    'zh-tw': '聯繫人姓名',
    'en': 'Contact Name'
  },
  creditCode: {
    'zh-cn': '统一社会信用代码',
    'zh-tw': '統一社會信用代碼',
    'en': 'Unified Social Credit Code'
  },
  contactPhone: {
    'zh-cn': '联系人手机号',
    'zh-tw': '聯繫人手機號',
    'en': 'Contact Phone'
  },
  view: {
    'zh-cn': '查看',
    'zh-tw': '查看',
    'en': 'View'
  },
  edit: {
    'zh-cn': '编辑',
    'zh-tw': '編輯',
    'en': 'Edit'
  },
  operation: {
    'zh-cn': '操作',
    'zh-tw': '操作',
    'en': 'Operation'
  },
  // 对话框标题
  createOrganization: {
    'zh-cn': '创建组织机构',
    'zh-tw': '創建組織機構',
    'en': 'Create Organization'
  },
  editOrganization: {
    'zh-cn': '编辑组织机构',
    'zh-tw': '編輯組織機構',
    'en': 'Edit Organization'
  },
  enterpriseCertificationInfo: {
    'zh-cn': '企业认证信息',
    'zh-tw': '企業認證信息',
    'en': 'Enterprise Certification Information'
  },
  // 删除确认
  deleteConfirm: {
    'zh-cn': '你确定要删除机构"{name}"吗?',
    'zh-tw': '你確定要刪除機構"{name}"嗎?',
    'en': 'Are you sure to delete organization "{name}"?'
  },
  deleteSuccess: {
    'zh-cn': '删除成功',
    'zh-tw': '刪除成功',
    'en': 'Delete successful'
  },
  // 表单标签
  parentOrganizationLabel: {
    'zh-cn': '所属上级',
    'zh-tw': '所屬上級',
    'en': 'Parent Organization'
  },
  contactNameLabel: {
    'zh-cn': '联系人姓名',
    'zh-tw': '聯繫人姓名',
    'en': 'Contact Name'
  },
  contactPhoneLabel: {
    'zh-cn': '联系人手机号',
    'zh-tw': '聯繫人手機號',
    'en': 'Contact Phone'
  },
  businessLicense: {
    'zh-cn': '公司营业执照',
    'zh-tw': '公司營業執照',
    'en': 'Business License'
  },
  legalPersonIDCard: {
    'zh-cn': '法人身份证',
    'zh-tw': '法人身份證',
    'en': 'Legal Person ID Card'
  },
  // 占位符和提示
  pleaseKeepConsistentWithLicense: {
    'zh-cn': '请与营业执照名称保持一致',
    'zh-tw': '請與營業執照名稱保持一致',
    'en': 'Please keep consistent with business license name'
  },
  dragFileOrClickUpload: {
    'zh-cn': '将文件拖拽到此处或 点击上传',
    'zh-tw': '將文件拖拽到此處或 點擊上傳',
    'en': 'Drag file here or click to upload'
  },
  uploadImageFormatTip: {
    'zh-cn': '上传图片格式只能为jpg、jpeg、png，分辨率不能超过5000×5000，且大小不能超过5M',
    'zh-tw': '上傳圖片格式只能為jpg、jpeg、png，分辨率不能超過5000×5000，且大小不能超過5M',
    'en': 'Upload image format must be jpg, jpeg, or png, resolution cannot exceed 5000×5000, and size cannot exceed 5M'
  },
  idCardFront: {
    'zh-cn': '身份证头像页',
    'zh-tw': '身份證頭像頁',
    'en': 'ID Card Front'
  },
  idCardBack: {
    'zh-cn': '身份证国徽页',
    'zh-tw': '身份證國徽頁',
    'en': 'ID Card Back'
  },
  submit: {
    'zh-cn': '提交',
    'zh-tw': '提交',
    'en': 'Submit'
  },
  // 验证消息
  pleaseSelectParentOrganization: {
    'zh-cn': '请选择所属机构',
    'zh-tw': '請選擇所屬機構',
    'en': 'Please select parent organization'
  },
  pleaseInputOrganizationName: {
    'zh-cn': '请输入机构名称',
    'zh-tw': '請輸入機構名稱',
    'en': 'Please input organization name'
  },
  creditCodeCannotBeEmpty: {
    'zh-cn': '统一社会信用代码不能为空',
    'zh-tw': '統一社會信用代碼不能為空',
    'en': 'Unified social credit code cannot be empty'
  },
  pleaseInputContact: {
    'zh-cn': '请输入联系人',
    'zh-tw': '請輸入聯繫人',
    'en': 'Please input contact'
  },
  pleaseInputContactPhone: {
    'zh-cn': '请输入联系电话',
    'zh-tw': '請輸入聯繫電話',
    'en': 'Please input contact phone'
  },
  // 消息提示
  requestFailed: {
    'zh-cn': '请求失败',
    'zh-tw': '請求失敗',
    'en': 'Request failed'
  },
  fileUploadFailed: {
    'zh-cn': '文件上传失败',
    'zh-tw': '文件上傳失敗',
    'en': 'File upload failed'
  },
  createSuccess: {
    'zh-cn': '创建成功',
    'zh-tw': '創建成功',
    'en': 'Create successful'
  },
  editSuccess: {
    'zh-cn': '修改成功',
    'zh-tw': '修改成功',
    'en': 'Edit successful'
  },
  // 文件名称
  businessLicenseFileName: {
    'zh-cn': '营业执照',
    'zh-tw': '營業執照',
    'en': 'Business License'
  },
  idCardFrontFileName: {
    'zh-cn': '身份证头像页',
    'zh-tw': '身份證頭像頁',
    'en': 'ID Card Front'
  },
  idCardBackFileName: {
    'zh-cn': '身份证国徽页',
    'zh-tw': '身份證國徽頁',
    'en': 'ID Card Back'
  }
}

